import { memo, type ReactNode } from 'react'
import { PagebuilderSectionNames } from 'cms/constants/pagebuilder'
import dynamic from 'next/dynamic'

import { SectionErrorBoundary } from './components/SectionErrorBoundary'
import type { PagebuilderSectionViewModel } from './types'

const PagebuilderBaseContentSection = dynamic(
  () => import('./components/sections/PagebuilderBaseContentSection')
)
const PagebuilderSplitContentSection = dynamic(
  () => import('./components/sections/PagebuilderSplitContentSection')
)
const PagebuilderTilesGridSection = dynamic(
  () => import('./components/sections/PagebuilderTilesGridSection')
)
const PagebuilderBannersGridSection = dynamic(
  () => import('./components/sections/PagebuilderBannersGridSection')
)
const PagebuilderMarqueeSection = dynamic(
  () => import('./components/sections/PagebuilderMarqueeSection')
)
const PagebuilderNewsletterSection = dynamic(
  () => import('./components/sections/PagebuilderNewsletterFormSection')
)

interface PagebuilderSectionResolverProps {
  section: PagebuilderSectionViewModel
}

export const PagebuilderSectionResolver = memo(
  ({ section }: PagebuilderSectionResolverProps) => {
    let resolvedSection: ReactNode = null

    switch (section?._type) {
      case PagebuilderSectionNames.pagebuilderBaseContentSection:
        resolvedSection = <PagebuilderBaseContentSection section={section} />
        break
      case PagebuilderSectionNames.pagebuilderSplitContentSection:
        resolvedSection = <PagebuilderSplitContentSection section={section} />
        break
      case PagebuilderSectionNames.pagebuilderTilesGridSection:
        resolvedSection = <PagebuilderTilesGridSection section={section} />
        break
      case PagebuilderSectionNames.pagebuilderBannersGridSection:
        resolvedSection = <PagebuilderBannersGridSection section={section} />
        break
      case PagebuilderSectionNames.pagebuilderMarqueeSection:
        resolvedSection = <PagebuilderMarqueeSection section={section} />
        break
      case PagebuilderSectionNames.pagebuilderNewsletterFormSection:
        resolvedSection = <PagebuilderNewsletterSection section={section} />
        break
      default:
        return <></>
    }

    return (
      <SectionErrorBoundary
        sectionType={section?._type}
        sectionId={section?.id}
      >
        {resolvedSection}
      </SectionErrorBoundary>
    )
  }
)
